import './pagination.less'

import {Icon, View, classes, m} from '@codeurs/front'

import {Ref} from 'util/ref'

const Page = ({children, active, ...rest}) => [
	m('a.paginationpage',
		{
			...classes({is: {active}}),
			...rest
		},
		children
	)
]

export class Pagination extends View<{
	current: Ref<number>
	total: number
	pagesToShow?: number
	separator: any // Todo: create view class/function type in front
	page: any
}> {
	render = this.render

	view() {
		const {
			current,
			total,
			pagesToShow = 5,
			page: Page,
			separator: Separator
		} = this.attrs
		const selected = current() || 0
		const page = index =>
			m(Page,
				{
					active: index - 1 === selected,
					onclick: () => current(index - 1)
				},
				index
			)
		const offset = Math.floor(pagesToShow / 2)
		const start = Math.max(
			Math.min(Math.max(1, selected - offset), total - pagesToShow - 1),
			1
		)
		return m('.pagination',
			page(1),
			start > 1 && m(Separator),
			Array.from(Array(pagesToShow)).map((_, i) => {
				const index = start + i
				return index < total - 1 && page(index + 1)
			}),
			start + pagesToShow < total - 1 && m(Separator),
			total > 1 && page(total)
		)
	}
}

export class PaginationThemed extends View<{
	current: Ref<number>
	total: number
}> {
	render = this.render

	view() {
		const {children, current, total} = this.attrs
		const selected = current() || 0
		return m('.paginationthemed', [
			m('a.paginationthemed-nav',
				{
					...classes({is: {inactive: selected === 0}}),
					onclick: () => current(selected - 1)
				},
				m(Icon, {icon: 'caret-left'})
			),
			m(Pagination,
				{
					current,
					total,
					page: Page,
					separator: () => '...'
				},
				children
			),
			m('a.paginationthemed-nav',
				{
					...classes({is: {inactive: selected >= total - 1}}),
					onclick: () => {
						current(selected + 1)
					}
				},
				m(Icon, {icon: 'caret-right'})
			)
		])
	}
}
